"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetLazyComponentPublic = exports.LazyComponentLoader = exports.LAZY_WIDGET_BUNDLE_FILE_NAME = void 0;
var Widget_1 = require("@wix/cashier-core/dist/src/services/Widget");
var react_1 = __importDefault(require("react"));
var ModuleRegistry_1 = require("@wix/cashier-common/dist/src/rmc-fork/ModuleRegistry");
var ReactLazyComponent_1 = require("@wix/cashier-common/dist/src/rmc-fork/ReactLazyComponent");
var InteractionName_1 = require("../types/InteractionName");
var fedopsLogger_1 = require("../utils/fedopsLogger");
var filterDefined_1 = require("../utils/filterDefined");
var logDeprecationNote_1 = require("../utils/logDeprecationNote");
var perfNow_1 = require("../utils/perfNow");
var config_1 = require("./config");
var hasDebugParam_1 = require("./hasDebugParam");
var LazyLoadError_1 = require("./LazyLoadError");
exports.LAZY_WIDGET_BUNDLE_FILE_NAME = 'cashier-widget-lazy-component';
var LazyComponentLoader = /** @class */ (function (_super) {
    __extends(LazyComponentLoader, _super);
    function LazyComponentLoader(props) {
        return _super.call(this, props, {
            component: config_1.LAZY_WIDGET_ID,
            files: LazyComponentLoader.buildFiles(props),
            crossorigin: true,
        }) || this;
    }
    LazyComponentLoader.buildFiles = function (props) {
        var isDebug = props.debug || (0, hasDebugParam_1.hasDebugParam)();
        return [
            "".concat(props.widgetSettings.widgetStaticsBaseUrl).concat(exports.LAZY_WIDGET_BUNDLE_FILE_NAME, ".bundle").concat(isDebug ? '' : '.min', ".js"),
        ];
    };
    return LazyComponentLoader;
}(ReactLazyComponent_1.ReactLazyComponent));
exports.LazyComponentLoader = LazyComponentLoader;
var WidgetLazyComponentPublic = /** @class */ (function (_super) {
    __extends(WidgetLazyComponentPublic, _super);
    function WidgetLazyComponentPublic(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._isMounted = true;
        _this.onApiInitListeners = [];
        _this.loadStartTime = (0, perfNow_1.perfNow)();
        _this.state = {
            widgetSettings: null,
            isLazyLoadFailed: false,
        };
        _this.handleApiInit = function (api) {
            if (_this.props.onApiInit) {
                _this.props.onApiInit(api);
            }
            // deprecated way of notifying the consumer
            _this.widgetAPI = api;
            _this.onApiInitListeners.forEach(function (listener) { return listener(api); });
        };
        _this.onCrashSafe = function (error) {
            if (_this.props.onCrash) {
                // puts callback execution in the queue, which prevents current stack execution from halting if
                // callback throws error
                setTimeout(function () {
                    _this.props.onCrash(error);
                });
            }
        };
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.ALE);
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.ALE_MOUNT);
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LAZY_COMPONENT_LOAD);
        // based on invocation https://github.com/wix/react-module-container/blob/master/src/base-lazy-component.js#L27
        _this.removeLoadFailureListener = (0, ModuleRegistry_1.getModuleRegistry)().addListener('reactModuleContainer.error', function (error) {
            var _a, _b;
            // based on structure from https://github.com/wix/react-module-container/blob/master/src/ReactModuleContainerErrors.js#L39
            if ((error === null || error === void 0 ? void 0 : error.name) === 'LazyComponentLoadingError' &&
                (((_a = error.message) === null || _a === void 0 ? void 0 : _a.endsWith(config_1.LAZY_WIDGET_ID)) || ((_b = error.message) === null || _b === void 0 ? void 0 : _b.endsWith(config_1.WIDGET_ID)))) {
                console.error("Payments Widget: Failed to load main bundle", error);
                _this.setState({ isLazyLoadFailed: true });
                _this.onCrashSafe(error);
            }
        }).remove;
        return _this;
    }
    WidgetLazyComponentPublic.prototype.componentDidMount = function () {
        this.fetchWidgetSettings();
    };
    WidgetLazyComponentPublic.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        if (typeof this.removeLoadFailureListener === 'function') {
            this.removeLoadFailureListener();
        }
    };
    WidgetLazyComponentPublic.prototype.fetchWidgetSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var widgetSettings, fetchWidgetSettingsPromise, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        widgetSettings = void 0;
                        if (!WidgetLazyComponentPublic.fetchWidgetSettingsPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, WidgetLazyComponentPublic.fetchWidgetSettingsPromise];
                    case 1:
                        // cached
                        widgetSettings = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        fetchWidgetSettingsPromise = new Widget_1.WidgetService({
                            baseURL: this.props.host,
                            appInstance: this.props.configuration.appInstance,
                            revalidateAppInstance: this.props.revalidateAppInstance,
                        }).fetchWidgetSettings((0, filterDefined_1.filterDefined)({ msid: this.props.configuration.msid }));
                        return [4 /*yield*/, fetchWidgetSettingsPromise];
                    case 3:
                        widgetSettings = _a.sent();
                        // we don't want to cache during tests/in storybook/in dev env
                        if (!widgetSettings.hasOwnProperty('dev')) {
                            WidgetLazyComponentPublic.fetchWidgetSettingsPromise = fetchWidgetSettingsPromise;
                        }
                        _a.label = 4;
                    case 4:
                        if (this._isMounted) {
                            this.setState({ widgetSettings: widgetSettings });
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error("Payments Widget: Failed to resolve widget settings", error_1);
                        this.setState({ isLazyLoadFailed: true });
                        this.onCrashSafe(error_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    WidgetLazyComponentPublic.prototype.getApi = function () {
        var _this = this;
        (0, logDeprecationNote_1.logDeprecationNote)("\"getApi\" method is deprecated. Use \"onApiInit\" prop to retrieve Widget's API");
        return new Promise(function (resolve) {
            if (_this.widgetAPI) {
                resolve(_this.widgetAPI);
            }
            else {
                _this.onApiInitListeners.push(resolve);
            }
        });
    };
    WidgetLazyComponentPublic.prototype.render = function () {
        var _a = this.state, widgetSettings = _a.widgetSettings, isLazyLoadFailed = _a.isLazyLoadFailed;
        if (isLazyLoadFailed) {
            return react_1.default.createElement(LazyLoadError_1.LazyLoadError, { isModalTheme: this.props.theme === 'modal' });
        }
        if (widgetSettings === null) {
            return null;
        }
        return (react_1.default.createElement(LazyComponentLoader, __assign({}, this.props, { startLoadTime: this.loadStartTime, widgetSettings: widgetSettings, fedopsLogger: fedopsLogger_1.fedopsLogger, loadInfo: {
                loaderStartTime: this.loadStartTime,
            }, onApiInit: this.handleApiInit, onCrash: this.onCrashSafe })));
    };
    return WidgetLazyComponentPublic;
}(react_1.default.Component));
exports.WidgetLazyComponentPublic = WidgetLazyComponentPublic;
//# sourceMappingURL=WidgetLazyComponent.public.js.map